export const filters = [
    {
        "type": "string",
        "name": "searchtext",
        "label": "Search",
        "width": "full",
        "disabled": false,
    },
    {
        "type": "date",
        "name": "startdate",
        "defaultValue": "TODAY",
        "label": "From Date",
        "disabled": false,
    },
    {
        "type": "date",
        "name": "enddate",
        "label": "To Date",
        "disabled": false,
    },
    {
        "type": "string",
        "name": "brokernum",
        "label": "Broker Number",
        "disabled": false,
    },
    {
        "type": "string",
        "name": "policynum",
        "label": "Policy Number",
        "disabled": false,
    },
    {
        "type": "multi-select",
        "name": "type",
        "label": "Type",
        "disabled": false,
        "values": [
            {
                "value": "OUTDOC"
            },
            {
                "value": "OUTBOUND"
            }
        ]
    },
    {
        "type": "multi-select",
        "name": "state",
        "label": "Status",
        "defaultValue": ["ERROR"],
        "disabled": false,
        "values": [
            {
                "value": "IDLE"
            },
            {
                "value": "RUNNING"
            },
            {
                "value": "DEAD"
            },
            {
                "value": "ERROR"
            }
        ]
    }
]

export const getFilter = (name: string) => {
    const fil = filters.find((fil) => fil.name === name);
    return fil;
}

export type FilterConfig = typeof filters
export type Filter = typeof filters[0]